import React, { PureComponent } from 'react';
import PT from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import classes from './ScheduleDetails.css';

export default class ScheduleDetails extends PureComponent {
  static propTypes = {
    type: PT.string.isRequired,
  };

  render() {
    const { type } = this.props;

    const legendClass = classNames({
      monday: type === 'monday',
      thursday: type === 'thursday',
      saturday: type === 'saturday',
      bye: type === 'bye',
      london: type === 'london',
      mexicoCity: type === 'mexicoCity',
      frankfurt: type === 'frankfurt',
      [classes.scheduleDetails]: true,
    });

    return (
      <div className={legendClass}>
        <div />
        {`${_.startCase(type)}`}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/TableControls/ScheduleDetails/ScheduleDetails.js